<template>
<section class="content">
    <div>
        <div v-if="cityAdmin">
            <div :class="addButtonClass">
                <div class="monitoring-link">
                    <a v-if="traccarUrl == '' || traccarUrl == null" disabled class="non-clickable" v-tooltip.hover title="Data not found">Vehicle Monitoring</a>
                    <a v-if="traccarUrl" :href="traccarUrl" target="_blank">Vehicle Monitoring</a>

                </div>
            </div>

            <v-server-table ref="vehicleTripTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                <template slot="beforeBody">
                    <tr v-if="loading" class="VueTables__no-results">
                        <td class="text-center" colspan="9">
                            <pulse-loader></pulse-loader>
                        </td>
                    </tr>
                </template>

                <template slot="action" slot-scope="props">
                    <div class="active_wrp">
                        <a class="fa fa-car" role="button" v-on:click.stop="action(props.row)"></a>

                    </div>
                </template>

            </v-server-table>

            <div class="col-md-12 map_view_wrp newiframewrp">
                <!-- <div class="col-md-6 map-view">
          <div
            id="iframe-wrapper"
            :style="iframe.wrapperStyle" 
          >
            <iframe 
              v-if="loaded"
              src="https://demo.traccar.org/?token=SDBGAiEAwVH6o9jNTrsQpb66GomkS4_pUFiM5dL_iaL17KuDFzsCIQCq-pGAyCkd5lIySnIVcuAsjL8GJYknZl3x6eWZL6mq0XsidSI6MzkzMDEsImUiOiIyMDIzLTA3LTEzVDE4OjMwOjAwLjAwMCswMDowMCJ9"
              :style="iframe.style"
              :height="iframe.style.height"
              :width="iframe.style.width"
              frameborder="0"
            ></iframe>
          </div>
        </div> -->
                <!-- <div class="col-md-12 h-80"> -->
                <!-- <div class="large-12 columns subcattable monitor">
            <table class="test-table">
              <thead>
                <tr>
                  <th>Driver Name</th>
                  <th>Helper Name</th>
                  <th>Vehicle</th>
                  <th>Trip Status</th>
                  <th>Last Updated</th>
                </tr>
              </thead>
              <tbody v-if="tripList.length != 0">
                <tr v-for="(trip, index) in tripList" :key="index">
                  <td>{{trip.driverName}}</td>
                  <td>{{trip.helperName}}</td>
                  <td>{{trip.vehicle}}</td>
                  <td>{{trip.tripStatus}}</td>
                  <td>{{trip.lastUpdated}}</td>
                </tr>
              </tbody>
              <tbody v-if="tripList.length == 0">
              <tr>
                <td colspan="6">
                  <div class="text-center"> No Records Found </div>
                </td>
              </tr>
            </tbody>
            </table>
          </div> -->

                <!-- <div class="vehicle-list">
            <div class="p-relative">
                <input v-on:keyup="keyHandler" type="text" placeholder="Search Anything Here" name="" id="" class="w-100 wrapper-border h-30 pd-left-25">
                <img src="/static/img/search_black.png" v-if="isSearching" class="search-img" alt="">
            </div>
            <div class="vehicle-details pd-10 c-pointer" v-on:click="houseLocationOnMap">
                <div class="col-md-10 d-flex flex-column outer-padding-none">
                    <div class="trip-desc">
                        <img src="/static/img/ongoing.png" alt="">
                        <span>A trip has been started from</span>
                        <span>Sector 59</span>
                        <span>at</span>
                        <span>06:22 AM</span>
                        <span>on</span> 
                        <span>08-06-2023</span>
                    </div>
                    <div class="d-flex flex-row">
                        <div class="right-divider pd-10">
                            <img src="/static/img/driver_logo.png">
                            <span class="bold-name">AKASH </span><span> KUMAR</span>
                        </div>
                        <div class="right-divider ml-10 pd-10">
                            <img src="/static/img/helper.png">
                            <span class="bold-name">VIKAS </span><span> KUMAR</span>
                        </div>
                        <div class="ml-10 pd-10">
                            <span>Last updated at:</span>
                            <span>08-06-2023, 06:22 AM</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 d-flex flex-column plate-wrapper pd-0">
                    <div class="vehicle-number-plate d-flex" >
                        <div class="plate-tag">
                            <span>IND</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="number-child-1">UP 16 DJ</span>
                            <span class="number-child-2">1691</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vehicle-details pd-10">
                <div class="col-md-10 d-flex flex-column outer-padding-none">
                    <div class="trip-desc">
                        <img src="/static/img/complete-trip.png" alt="">
                            <span>A trip has been completed for</span>
                            <span>Sector 59</span>
                            <span>at</span> 
                            <span>06:22 AM</span>
                            <span>on</span> 
                            <span>08-06-2023</span>
                            <span>and completed at</span>
                            <span>06:22 AM</span>
                            <span>on</span>
                            <span>08-06-2023</span>
                    </div>
                    <div class="d-flex flex-row">
                        <div class="right-divider pd-10">
                            <img src="/static/img/driver_logo.png">
                            <span class="bold-name">AKASH </span><span> KUMAR</span>
                        </div>
                        <div class="right-divider ml-10 pd-10">
                            <img src="/static/img/helper.png">
                            <span class="bold-name">VIKAS </span><span> KUMAR</span>
                        </div>
                        <div class="ml-10 pd-10">
                            <span>Last updated at:</span>
                            <span>08-06-2023, 06:22 AM</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 d-flex flex-column plate-wrapper pd-0">
                    <div class="vehicle-number-plate d-flex" >
                        <div class="plate-tag">
                            <span>IND</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="number-child-1">UP 16 DJ</span>
                            <span class="number-child-2">1691</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vehicle-details pd-10">
                <div class="col-md-10 d-flex flex-column outer-padding-none">
                    <div class="trip-desc">
                        <img src="/static/img/waiting.png" alt="">
                        <span>Vehicle is waiting for a trip to be assigned.</span>
                    </div>
                    <div class="d-flex flex-row">
                        <div class="right-divider pd-10">
                            <img src="/static/img/driver_logo.png">
                            <span class="bold-name">AKASH </span><span> KUMAR</span>
                        </div>
                        <div class="right-divider ml-10 pd-10">
                            <img src="/static/img/helper.png">
                            <span class="bold-name">VIKAS </span><span> KUMAR</span>
                        </div>
                        <div class="ml-10 pd-10">
                            <span>Last updated at:</span>
                            <span>08-06-2023, 06:22 AM</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 d-flex flex-column plate-wrapper pd-0">
                    <div class="vehicle-number-plate d-flex" >
                        <div class="plate-tag">
                            <span>IND</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="number-child-1">UP 16 DJ</span>
                            <span class="number-child-2">1691</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vehicle-details pd-10">
                <div class="col-md-10 d-flex flex-column outer-padding-none">
                    <div class="trip-desc">
                        <img src="/static/img/scheduled.png" alt="">
                        <span>A trip has been scheduled for</span>
                        <span>Sector 59</span>
                        <span>at</span>
                        <span>06:22 AM</span>
                        <span>on</span>
                        <span>08-06-2023</span>
                    </div>
                    <div class="d-flex flex-row">
                        <div class="right-divider pd-10">
                            <img src="/static/img/driver_logo.png">
                            <span class="bold-name">AKASH </span><span> KUMAR</span>
                        </div>
                        <div class="right-divider ml-10 pd-10">
                            <img src="/static/img/helper.png">
                            <span class="bold-name">VIKAS </span><span> KUMAR</span>
                        </div>
                        <div class="ml-10 pd-10">
                            <span>Last updated at:</span>
                            <span>08-06-2023, 06:22 AM</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 d-flex flex-column plate-wrapper pd-0">
                    <div class="vehicle-number-plate d-flex" >
                        <div class="plate-tag">
                            <span>IND</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="number-child-1">UP 16 DJ</span>
                            <span class="number-child-2">1691</span>
                        </div>
                    </div>
                </div>
            </div>

        </div> -->
                <!-- </div> -->
            </div>

        </div>

        <div v-if="!cityAdmin" class="monitoring-link" style="justify-content:center">
            <a href="https://tracker.goaheadtechnologies.in/" target="_blank">Click here to login to Traccar</a>
        </div>
    </div>

</section>
</template>

<script>
import locationTracking from "../gmapLocation/tracking.vue";
import {
    eventBus,
    dutyTrackingService
} from "../../../services";
import dateFormatter from "../../utilities/dateFormate";

export default {
    name: "monitoring",
    components: {
        locationTracking,
    },
    data() {
        return {
            iframe: {
                src: "",
                style: null,
                wrapperStyle: null,
            },
            tripList: [],
            loading: false,
            cityAdmin: false,
            driverList: [],
            surveyorList: [],
            city: {},
            cityList: [],
            traccarUrl: "",
            loaded: false,
            isMapActive: false,
            houseLocation: true,
            staffLocationRefresh: null,
            isSearching: true,
            vehicleTripTable: null,
            vehicleListRefresh: null,
            parameters: {},
            columns: [
                "vehicle",
                "zone",
                "driver",
                "helper",
                "tripTime",
                "nextTrip",
                "lastUpdate",
                "action"
            ],
            tableOptions: {
                texts: {
                    filterPlaceholder: 'Search vehicle Number',
                }
            },
            options: {
                heightlighted: true,
                headings: {
                    vehicle: "Vehicle",
                    zone: "Zone",
                    driver: "Driver Name",
                    helper: "Helper Name",
                    tripTime: "Trip Time",
                    nextTrip: "Next Trip",
                    lastUpdate: "Last Updated Time",
                    action: "Action"
                },
                perPage: 10,
                sortable: ["vehicle"],

                requestFunction: (request) => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    this.parameters.cityId = this.$store.state.auth.user.cityId._id;
                    if (request.query) {
                        this.parameters.searchString = request.query.trim();
                    } else {
                        delete this.parameters.searchString;
                    }
                    if (request.orderBy) {
                        if (request.orderBy == "vehicle") {
                            this.parameters.sortBy = "vNumber"
                        }
                        if (request.ascending == 1) {
                            this.parameters.sortOrder = "asc";
                        } else {
                            this.parameters.sortOrder = "dsc";
                        }
                    }

                    return dutyTrackingService.tripMonitoring(this.parameters).catch((error) => {
                        console.error("trip.requestFunction-error:", error);
                        this.$snotify.error("Get Trip List", "Error!");
                    });
                },
                responseAdapter: (response) => {
                    let vehiclTripList = []
                    let count
                    response.data.response.forEach((element) => {
                        let vehicleRecord = {}
                        vehicleRecord = element;
                        vehicleRecord['vehicle'] = element.vModelName ? element.vModelName + "(" + element.vNumber + ")" : element.vNumber;
                        vehicleRecord['lastUpdate'] = element.lastUpdate ? dateFormatter(element.lastUpdate) : '--';
                        // vehicleRecord['tripTime'] = '--';
                        // vehicleRecord['nextTrip'] = '--';
                        if (element.hasOwnProperty('completedTrips') && element.completedTrips != null) {
                            vehicleRecord['zone'] = element.completedTrips.wasteCollectionAreaName;
                            vehicleRecord['driver'] = element.completedTrips.driverFirstName + " " + element.completedTrips.driverLastName;
                            vehicleRecord['helper'] = element.completedTrips.helperFirstName + " " + element.completedTrips.helperLastName;
                            if (element.ongoingTrips == null) {
                                vehicleRecord['tripTime'] = dateFormatter(element.completedTrips.startTime) + " to " + dateFormatter(element.completedTrips.endTime);
                            }
                            vehicleRecord['nextTrip'] = '--';
                        }

                        if (element.hasOwnProperty('upcomingTrips') && element.upcomingTrips != null) {
                            vehicleRecord['zone'] = element.upcomingTrips.wasteCollectionAreaName;
                            vehicleRecord['driver'] = element.upcomingTrips.driverFirstName + " " + element.upcomingTrips.driverLastName;
                            vehicleRecord['helper'] = element.upcomingTrips.helperFirstName + " " + element.upcomingTrips.helperFirstName;
                            vehicleRecord['tripTime'] = '--'
                            vehicleRecord['nextTrip'] = element.upcomingTrips.scheduleTime ? dateFormatter(element.upcomingTrips.scheduleTime) : '--';
                        }

                        if (element.hasOwnProperty('ongoingTrips') && element.ongoingTrips != null) {
                            vehicleRecord['zone'] = element.ongoingTrips.wasteCollectionAreaName;
                            vehicleRecord['driver'] = element.ongoingTrips.driverFirstName + " " + element.ongoingTrips.driverLastName;
                            vehicleRecord['helper'] = element.ongoingTrips.helperFirstName + " " + element.ongoingTrips.helperFirstName;
                            vehicleRecord['tripTime'] = dateFormatter(element.ongoingTrips.startTime) + "(On Going)";
                            vehicleRecord['nextTrip'] = '--';
                        }
                        vehiclTripList.push(vehicleRecord);
                    })
                    if (vehiclTripList.length === 0) {
                        count = 0;
                    }
                    return {
                        data: vehiclTripList,
                        count: response.data.totalCount[0].count || count,
                    };
                },
            },
        };
    },
    methods: {

        action(data) {
            let vehicleId = data.vehicleId;
            return dutyTrackingService
                .vehicleMoniter(vehicleId)
                .then((response) => {               
                    if (response.data.response) {
                        const newTab = window.open(response.data.response, "_blank");
                    }else {                        
                        this.$snotify.error(response.data.error, "Error!");
                    }

                })
                .catch((error) => {
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error(error, "Error!");
                    }

                });

        },

        customizeFilterPlaceholder() {
            const vehicleTripTable = this.$refs.vehicleTripTable;
            if (vehicleTripTable && vehicleTripTable.$el) {
                const filterInput = vehicleTripTable.$el.querySelector('.VueTables__search-field input');
                if (filterInput) {
                    filterInput.setAttribute('placeholder', 'Search Vehicle Number');
                }
            }

        },

        onLoaded() {
            this.vehicleTripTable = this.$refs.vehicleTripTable;
        },
        getTraccarUrl() {
            return dutyTrackingService.getTraccarToken().then((response) => {
                this.traccarUrl = response.data.response
                this.iframe.src = response.data.response

            }).catch((error) => {
                this.loading = false;
                console.error("trackingService-error:", error);
                this.$snotify.error(error.data.message, "Error!");

            })
        }
    },

    computed: {
        addButtonClass() {

            if (this.vehicleTripTable) {
                return this.vehicleTripTable.count > this.vehicleTripTable.limit ||
                    this.vehicleTripTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        // ...mapState({
        //     user: (state) => state.auth.user,
        // }),
    },

    mounted() {
        this.customizeFilterPlaceholder();
        this.vehicleListRefresh = setInterval(() => {
            this.$refs.vehicleTripTable.refresh();
            this.getTraccarUrl();
        }, 2 * 60 * 1000);

        let editor = this.$refs.editor;
        this.iframe.style = {
            position: 'absolute',
            width: "110%",
            height: "80vh",
            top: "10px",
            left: "10px",
        }
        this.iframe.wrapperStyle = {
            overflow: 'hidden',
            height: "",
            width: "",
        }
        // this.iframe.src= this.traccarUrl
        this.loaded = true;
        // }
    },

    created() {
        this.adminCheck = this.$store.state.auth.user.role.key;
        if (this.adminCheck !== "superAdmin") {
            let cityId = this.$store.state.auth.user.cityId._id;
            // this.getTripList(cityId)
            if (this.$store.state.auth.user.traccarUserAssociated.userId) {
                this.getTraccarUrl();
            }

            this.cityAdmin = true;
        }
    },

    beforeDestroy() {
        clearInterval(this.vehicleListRefresh)
    }
};
</script>

<style>
.main_select_wrp_relative+.add-item {
    display: flex;
}

.test-table {
    margin-left: 80px;
}

.subcattable table {
    margin-left: 0px;
}

.subcattable table td,
.subcattable table th {
    border: 1px solid #f4f4f4;
}

.subcattable table tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}

.subcattable table tr:hover {
    background-color: #5e9cfe29 !important;
}

.edit_del_btn {
    border: 0;
    background-color: transparent;
    color: #35A2FE;
}

.subcattable table tr td:last-child {
    width: 200px;
}

.city_dropdown {
    display: flex;
    justify-content: space-between;
    margin: 20px 0px;
}

.city_rel_class {
    width: 150%;
}

.h-80 {
    height: 80vh;
}

.monitor {
    overflow: auto;
    height: 100%;
}

.driver-data .monitor {
    height: 290px !important;
}

.monitor table {
    width: 100%;
    margin: 0;
    position: relative;
    top: -2px
}

.monitor table thead {
    position: sticky;
    top: -1px;
}

.table-body-details {
    overflow: auto;
    height: 290px !important;
}

.wrapper-border {
    border: 2px solid #E0E0E0;
    border-radius: 6px;
}

.h-30 {
    height: 47px;
}

.vehicle-list input:focus-visible {
    outline: none;
    overflow-y: scroll;
}

.vehicle-details {
    position: relative;
    border: 2px solid #E0E0E0;
    border-radius: 6px;
    margin-top: 15px;
    min-height: 130px;
    border-left: 6px solid #35A2FE;
}

/* .bottom-divider:not(:last-child) {
    border-bottom: 1px solid #E0E0E0;
} */

.vehicle-number-plate {
    position: relative;
    justify-content: flex-end;
    padding-right: 10px;
    /* width: 118px; */
    width: 100%;
    height: 60px;
    background: #FFB900;
    border: 2px solid black;
    border-radius: 2px;
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(50%);
}

.plate-tag {
    position: absolute;
    left: 4px;
    top: 40%;
}

.plate-tag span {
    font-size: 7px;
    font-weight: 550;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: left;

}

.number-child-1 {
    font-family: Roboto;
    font-size: 15px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
}

.number-child-2 {
    font-family: Roboto;
    font-size: 24px;
    font-weight: 700;
    line-height: 27px;
    letter-spacing: 2px;
    text-align: center;
}

.right-divider {
    border-right: 1px solid #E0E0E0;
}

.ml-10 {
    margin-left: 10px;
}

.bold-name {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0px;
}

.trip-desc span:nth-child(odd) {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
}

.trip-desc span:nth-child(even) {
    font-size: 12px;
    font-weight: 400;
    line-height: 26px;
    color: #585858;
    padding: 10px 7px;
}

.outer-padding-none {
    padding: 0px 0px;
}

.location .vehicle-modal .form-modal {
    width: 80% !important;
    height: 80% !important;
    padding: 10px 15px;
    position: relative;
}

.table-position {
    position: absolute;
    bottom: 10px;
    width: 100%;
}

.search-img {
    position: absolute;
    transform: translateY(50%);
    z-index: 1;
    left: 2px;
}

.pd-left-25 {
    padding-left: 25px;
}

.vehicle-number-plate:before {
    position: absolute;
    content: "";
    top: 45%;
    left: 4px;
    width: 5px;
    height: 5px;
    background: #000;
    border-radius: 50%;
}

.vehicle-number-plate:after {
    position: absolute;
    content: "";
    top: 45%;
    right: 4px;
    width: 5px;
    height: 5px;
    background: #000;
    border-radius: 50%;
}

.pd-0 {
    padding: 0px;
}

/* .map-view{
  height: calc(100vh - 245px);
    overflow: auto;
} */
.vue-map-container {
    height: calc(100% - 20px) !important;
}

.vehicle-list {
    height: calc(100vh - 245px);
    overflow: auto;
}

.vehicle-list::-webkit-scrollbar,
.map-view::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.vehicle-list::-webkit-scrollbar-track,
.map-view::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.vehicle-list::-webkit-scrollbar-thumb,
.map-view::-webkit-scrollbar-thumb {
    background: #888;
}

.newiframewrp div[class^="root"] {
    background: red;
    width: 40%;
}

.root {
    background: red;
    width: 40%;
}

.monitoring-link {
    z-index: 1;
    display: flex;
    width: 100%;
    justify-content: end;
    /* padding-right: 30px; */
    margin-bottom: 20px;
    font-size: 19px;
    text-decoration: underline;
    color: #337ab7;
}

@media(max-width:1499px) {
    .number-child-2 {
        font-size: 17px;
    }

    .number-child-1 {
        font-size: 13px;
    }
}

@media(max-width:1399px) {
    .bold-name {
        font-size: 12px;
    }

    .right-divider span {
        font-size: 12px;
    }

    .trip-desc span:nth-child(odd) {
        font-size: 12px;
    }

    .number-child-1 {
        font-size: 10px;
    }

    .number-child-2 {
        font-size: 12px;
    }

    .vehicle-details {
        min-width: 500px;
    }

}

@media(max-width:991px) {
    .map_view_wrp {
        height: calc(100vh - 320px);
        overflow: auto;
    }

    .vehicle-list {
        height: auto;
        overflow: initial;
        margin-top: 20px;
    }

    .vehicle-details {
        display: flex;
    }

    .vehicle-details .col-md-10 {
        flex: 0 0 80%;
    }

    .vehicle-details .col-md-2 {
        flex: 0 0 20%;
    }

    .vehicle-number-plate {
        top: 0;
    }

    .number-child-1 {
        font-size: 16px;
    }
}

@media(max-width:767px) {
    .vehicle-list {
        overflow: auto;
    }
}

/* Example CSS for the tooltip */
.tooltip {
    background-color: #333;
    color: #fff;
    padding: 5px;
}
</style>



// WEBPACK FOOTER //
// vehicleTracking.vue?22834e5a